export default function Divisor({}){
    return(
        <div className="fields-divisor"></div>
    )
}